import { Layout, Typography } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { register } from 'src/features/AuthSlice'
import {
  AuthBackdrop,
  AuthHeading,
  AuthPageLayout,
  AuthSubheading,
  AuthSurface,
  AuthTrustText,
} from 'src/screens/login/authStyles'
import RegisterForm from 'src/screens/register/RegisterForm'

const Register = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.auth)
  const { error } = user

  const showError = error =>
    error.code === 'InvalidParameterException'
      ? 'Password must be greater than 8 characters'
      : error.message

  return (
    <AuthPageLayout className='layout'>
      <AuthBackdrop />
      <Layout.Content>
        <AuthSurface>
          <AuthHeading level={2}>Create your account</AuthHeading>
          <AuthSubheading>
            Set up secure access to your Orders Made Simple workspace.
          </AuthSubheading>
          <RegisterForm
            user={user}
            submit={values => dispatch(register(values))}
          />
          {error && (
            <Typography.Text type='danger'>{showError(error)}</Typography.Text>
          )}
          <AuthTrustText>
            Secure registration protected by enterprise-grade authentication
          </AuthTrustText>
        </AuthSurface>
      </Layout.Content>
    </AuthPageLayout>
  )
}

export default Register
